import React, { useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "./../Layout/SideBar";
import { ROUTE_DASHBOARD } from '../RouteConstents';

const HeaderLayout = () => {

    //const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    const [showNavigationView, setShowNavigationView] = useState(0);
    //const [showPageTitle, setShowPageTitle] = useState('');

    //const navigate = useNavigate();

    const showNavigation = (e) => {
        
        if(showNavigationView === 0) {
            document.body.classList.add('overlay-open');
            setShowNavigationView(1);
        } else {
            document.body.classList.remove('overlay-open');
            setShowNavigationView(0); 
        } 

    }

    
    return (
    <>
        <div className="overlay"></div>
        <nav className="navbar">
            <div className="container-fluid">
                <div className="navbar-header">
                    <span onClick={showNavigation} className="bars"></span>
                    <Link className="navbar-brand" to={ROUTE_DASHBOARD}>SBS Application</Link>
                </div>
                
            </div>
        </nav>
        <SideBar/>
    </>
    );
   
}
    
export default HeaderLayout;